import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Group_Interface } from 'src/app/Interface/General_Group_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DorehAmoozeshiService {
  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<General_Group_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DorehAmoozeshi").pipe(
      map(data=>{
        return data as Array<General_Group_Interface>
      })
    )
  }

  GetActiveList(id:Number):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DorehAmoozeshi/GetActiveList?id="+id).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetSingle(id:Number):Observable<General_Group_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/DorehAmoozeshi/GetSingle?id="+id).pipe(
      map(data=>{
        return data as General_Group_Interface
      })
    )
  }

  AddDorehAmoozeshi(model: General_Group_Interface):Observable<General_Group_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      group_id:model.group_id,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/DorehAmoozeshi/Add",body,{headers}).pipe(
        map(data=>{
          return data as General_Group_Interface
        })
      )

  }

  EditDorehAmoozeshi(model: General_Group_Interface):Observable<General_Group_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      group_id:model.group_id,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/DorehAmoozeshi/Edit",body,{headers}).pipe(
        map(data=>{
          return data as General_Group_Interface
        })
      )

  }

  DeleteDorehAmoozeshi(id:number):Observable<General_Group_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/DorehAmoozeshi/Delete?id="+id).pipe(
        map(data=>{
          return data as General_Group_Interface
        })
      )

  }

  }
